import React from "react";

class FieldsForPS extends React.Component {

	refreshModel = (e) => {
		const { refreshModel, newOrderModel } = this.props;
		const { name, value } = e.target;

		const newOrderModelCopy = { ...newOrderModel };

		newOrderModelCopy[name] = value;

		refreshModel(newOrderModelCopy);
	};

	render() {
		const {
			idValidation,
			idModalOrigin,
			idModalDestiny,
			eventOnclick,
			message,
			button1,
			button2,
			eventOnclick2,
			shadow,
			newOrderModel,
		} = this.props;

		const { U_FMB_SCOP_CODE = "" } = newOrderModel;

		return (
			<div
				className="modal fade"
				id={idValidation}
				tabIndex="-1"
				role="dialog"
				aria-labelledby="validationModalTitle"
				aria-hidden="true"
				data-backdrop="static"
			>
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div
						className="modal-content"
						style={
							shadow
								? { boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px" }
								: { boxShadow: "none" }
						}
					>
						<div className="modal-body">
							<h4>{message}</h4>
							<div className="input-group mt-3 mb-3">
								<div className="input-group-prepend">
									<span className="input-group-text font-weight-bold">
										Código SCOP
									</span>
								</div>
								<input
									type="text"
									maxLength="11"
									className="form-control"
									id="U_FMB_SCOP_CODE"
									name="U_FMB_SCOP_CODE"
									value={U_FMB_SCOP_CODE}
									onChange={this.refreshModel}
								/>
							</div>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-secondary"
								data-dismiss="modal"
								data-target={idModalOrigin}
								data-toggle="modal"
								onClick={eventOnclick2}
							>
								{button2 == null ? "Cancelar" : button2}
							</button>
							<button
								type="button"
								className="btn btn-primary"
								onClick={eventOnclick}
							>
								{button1 == null ? "Aceptar" : button1}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default FieldsForPS;
